/**
 * Date formatting utilities for HOR and other modules
 * Ensures consistent local date formatting without UTC shifts
 */

/**
 * Convert a date to local YYYY-MM-DD format (no UTC shift)
 * @param {Date|string} d - Date object or YYYY-MM-DD string
 * @returns {string|null} - Local date string YYYY-MM-DD or null if invalid
 */
export function toLocalYMD(d) {
  const dt = (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) ? new Date(d+'T00:00') : new Date(d);
  if (Number.isNaN(dt.getTime())) return null;
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2,'0');
  const day = String(dt.getDate()).padStart(2,'0');
  return `${y}-${m}-${day}`; // local date, no UTC shift
}